'use client';

import { useReportWebVitals } from 'next/web-vitals';
import { trackEvent } from '@/lib/analytics';

/**
 * Core Web Vitals Reporter - sends LCP, FID, CLS, FCP, TTFB to PostHog
 * Google uses these for ranking. We need to track and optimize.
 */
export function WebVitals() {
  useReportWebVitals((metric) => {
    // Send to PostHog for analysis
    trackEvent('web_vital', {
      name: metric.name,
      value: Math.round(metric.name === 'CLS' ? metric.value * 1000 : metric.value),
      rating: metric.rating, // 'good' | 'needs-improvement' | 'poor'
      id: metric.id,
      navigationType: metric.navigationType,
      // Thresholds for reference:
      // LCP: good < 2.5s, poor > 4s
      // FID: good < 100ms, poor > 300ms
      // CLS: good < 0.1, poor > 0.25
      // FCP: good < 1.8s, poor > 3s
      // TTFB: good < 800ms, poor > 1800ms
    });
  });
  return null;
}
